import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Row, Col } from "react-bootstrap";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, moamad, eduOptions }) {
  const [newEdu, setNewEdu] = useState({
    mosad_name: "",
    education_type: "",
    city: "",
    edu_num: 0,
    end_year: 0,
    subject: "",
    diploma: "",
    moamad: moamad.id,
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewEdu((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "education/",
          newEdu,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  // render
  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3>
              ההשכלה של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="education_type">בחר סוג השכלה</label>
                    <select
                      name="education_type"
                      onChange={handleChange}
                      value={newEdu.education_type}
                      required
                    >
                      <option key="0" value="" selected>
                        בחר סוג
                      </option>
                      {eduOptions?.map((a) => (
                        <option key={a[0]} value={a[1]}>
                          {a[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <br></br>
                  <Row>
                    <Col>
                      <div className="form-cgroup">
                        <label htmlFor="mosad_name">שם מוסד</label>
                        <input
                          type="text"
                          name="mosad_name"
                          className="form-control"
                          id="mosad_name"
                          value={newEdu.mosad_name}
                          placeholder="כמו:הטכניון"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="city">היישוב של המוסד</label>
                        <input
                          type="text"
                          name="city"
                          className="form-control"
                          id="city"
                          value={newEdu.city}
                          placeholder="כמו: חיפה"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="subject">המקצוע העיקרי</label>
                        <input
                          type="text"
                          name="subject"
                          className="form-control"
                          id="subject"
                          value={newEdu.subject}
                          placeholder="כמו: הנדסה אזרחית"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <br></br>
                  </Row>
                  <Row>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="edu_num">מספר שנות לימוד</label>
                        <input
                          type="number"
                          name="edu_num"
                          className="form-control"
                          id="edu_num"
                          value={newEdu.edu_num}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="end_year">שנת סיום</label>
                        <input
                          type="number"
                          name="end_year"
                          className="form-control"
                          id="end_year"
                          min="1900"
                          max="2222"
                          value={newEdu.end_year}
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div className="form-group">
                        <label htmlFor="diploma">התואר או התעודה</label>
                        <input
                          type="text"
                          name="diploma"
                          className="form-control"
                          id="diploma"
                          value={newEdu.diploma}
                          placeholder="כמו:הנדסה BSC"
                          onChange={handleChange}
                        />
                      </div>
                    </Col>
                  </Row>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
